export const envConfig = {
    EMAIL: process.env.REACT_APP_EMAIL || "bhoomiukani8@gmail.com",
    NUMBER: process.env.REACT_APP_NUMBER || "7069821608",
    DEGREE_YEAR: 2024,
};